/* eslint-disable no-underscore-dangle */
import { setContentIsLoading, setDialogIsLoading } from '../loading';
import { sessionExpired } from '../auth';
import * as CPurposesAPI from '../../../api/cPurposes';


export const SET_CPURPOSES_LIST = 'SET_CPURPOSES_LIST';
export const SELECT_CPURPOSE = 'SELECT_CPURPOSE';
export const ADD_CPURPOSE = 'ADD_CPURPOSE';
export const REMOVE_CPURPOSE = 'REMOVE_CPURPOSE';


const selectCPurpose = value => ({
    type: SELECT_CPURPOSE,
    payload: value,
});
const setCPurposesList = value => ({
    type: SET_CPURPOSES_LIST,
    payload: value,
});

const setCPurposesListAsync = id => async (dispatch) => {
    dispatch(setContentIsLoading(true));
    try {
        const res = await CPurposesAPI.getByDoctorId(id);
        dispatch(setCPurposesList(res.data));
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setContentIsLoading(false));
};


const selectCPurposeAsync = id => async (dispatch) => {
    dispatch(setDialogIsLoading(true));
    try {
        const res = await CPurposesAPI.getById(id);
        dispatch(selectCPurpose(res.data));
    } catch (err) {
        sessionExpired(err, dispatch);
    }
    dispatch(setDialogIsLoading(false));
};

const addCPurpose = cPurpose => ({
    type: ADD_CPURPOSE,
    payload: cPurpose,
});


export {
    setCPurposesListAsync,
    selectCPurposeAsync,
    addCPurpose,

};
